const baseURL = 'https://217.77.13.31:8888';

export const createNewSubscription = async (email) => {
    const response = await fetch(`${baseURL}/create-subscription`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({email}),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    }
  };

export const getSubscriptions = async () => {
      const response = await fetch(`${baseURL}/get-subscriptions`);
      if (response.ok) {
          const data = await response.json();
          return data;
      }
      throw new Error('Failed to fetch subscriptions');
  };